module.exports = __webpack_public_path__ + "img/teaching_6_zh.90d2ff72.png";